import React from "react";
import "../../css/PrimaryButton.css";

const PrimaryButton = ({ children, variant = "filled", ...props }) => {
  return (
    <button
      className={`primary-btn ${variant === "outlined" ? "primary-btn--outlined" : "primary-btn--filled"}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
